import React, { useState } from 'react';
import './LevelGradeSelectionScreen.css';
import GradeSelectionScreen from './GradeSelectionScreen';

const LevelGradeSelectionScreen = ({ onSelect, onBack }) => {
  const [selectedLevel, setSelectedLevel] = useState(null);
  const [showGradeSelection, setShowGradeSelection] = useState(false);

  const educationLevels = [
    { value: 'middle', label: 'متوسط' },
    { value: 'high', label: 'ثانوي' }
  ];

  const handleLevelSelect = (level) => {
    setSelectedLevel(level);
    // الانتقال تلقائياً إلى شاشة اختيار الصف
    setShowGradeSelection(true);
  };

  const handleGradeSelected = (level, grade) => {
    onSelect(level, grade);
  };

  const handleBackToLevel = () => {
    setShowGradeSelection(false);
    setSelectedLevel(null);
  };

  const getLevelImage = (level) => {
    return level === 'middle' ? '/school.png' : '/school (1).png';
  };

  // إذا تم اختيار المرحلة وظهرت شاشة اختيار الصف
  if (showGradeSelection && selectedLevel) {
    return (
      <GradeSelectionScreen
        selectedLevel={selectedLevel}
        onSelect={handleGradeSelected}
        onBack={handleBackToLevel}
      />
    );
  }

  return (
    <div className="level-grade-screen">
      <div className="level-grade-container" style={{ position: 'relative' }}>
        <div className="selection-header">
          {onBack && (
            <button className="back-button ripple-effect magnetic-button" onClick={onBack}>
              ← رجوع
            </button>
          )}
          <h1 className="selection-title">اختر المرحلة</h1>
        </div>

        <div className="selection-content">
          <div className="level-cards">
            {educationLevels.map((level, index) => (
              <div
                key={level.value}
                className={`level-card ripple-effect stagger-item ${selectedLevel === level.value ? 'selected pulse-element' : ''}`}
                onClick={() => handleLevelSelect(level.value)}
                style={{
                  animationDelay: `${index * 0.1}s`
                }}
              >
                <div className="card-icon">
                  <img 
                    src={getLevelImage(level.value)} 
                    alt={level.value === 'middle' ? 'المرحلة المتوسطة' : 'المرحلة الثانوية'}
                    className="level-icon-image"
                  />
                </div>
                <div className="card-label">
                  {level.value === 'middle' ? 'المرحلة المتوسطة' : 'المرحلة الثانوية'}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="level-grade-footer">
          <p>مدير المدرسة: محمد نصر الدين</p>
        </div>
      </div>
    </div>
  );
};

export default LevelGradeSelectionScreen;

